// Before a reset or a logout: let the scene on screen settle what it still owes the server (the farm
// cancels its queue and waits for its last batch), so nothing lands in the new game or is lost to a
// 401. A scene with nothing pending has no settleForLeave; a failure to settle never blocks leaving.
export async function leaveSafely(scene, action) {
  try { await scene?.settleForLeave?.(); } catch (_) { /* leave anyway */ }
  return action();
}
